require('./bootstrap');
window.VanillaTilt = require('vanilla-tilt');
window.Splide = require('@splidejs/splide').default;

WOW = require('wowjs');